<template>
    <div class="container" ref="content">
        <div class="flex-grid">
            <div class="col">
                <h4> Kund </h4>
            </div>

            <div class="col"/>
            <div class="col">
                <span> {{ new Date() | moment("dddd, MMMM Do YYYY") }} </span>
            </div>
            <div class="col"/>
        </div>
     <br>
     <br>
        <div class="flex-grid">
            <div class="col">
                <b-form-input v-model="name"/>
                <b-form-input v-model="postnr "/>
                <b-form-input v-model="email" type="email"/>
            </div>

            <div class="col">
                <b-form-input v-model="adress" />
                <b-form-input v-model="ort"/>
                <b-form-input v-model="fastBet"  />
            </div>
        </div>
        <br>
        <br>
        <div class="flex-grid">
            <div class="col">
                <h4> Kommentarer </h4>
                <b-form-textarea v-model="customerComments"
                                 placeholder="Kundkommentarer"
                                 rows="7" max-rows="20" />
            </div>

            <div class="col"/>
        </div>

        <br>
        <br>

        <div class="flex-grid">
            <div class="col">
                <h4>Försyn</h4>
                <flat-pickr v-model="datum_forsyn" placeholder="-"></flat-pickr>
            </div>

            <div class="col">
                <h4>Markarbete</h4>
                <flat-pickr v-model="datum_digging" placeholder="-"></flat-pickr>
            </div>
            <div class="col"></div>
            <div class="col"></div>
        </div>

        <div class="flex-grid">


            <div class="col"></div>
            <div class="col"></div>
        </div>

        <hr>

        <hr>

        <div class="flex-grid">
            <div class="col">
                <h4>Försyn</h4>
                <img class="image" v-for="(image, i) in images_forsyn" :src="image" :key="i" @click="images_forsyn_index = i">
                <vue-gallery-slideshow :images="images_forsyn" :index="images_forsyn_index" @close="images_forsyn_index = null"></vue-gallery-slideshow>
            </div>

            <div class="col">
                <h4>Före</h4>
                <img class="image" v-for="(image, i) in images_before" :src="image" :key="i" @click="images_before_index = i">
                <vue-gallery-slideshow :images="images_before" :index="images_before_index" @close="images_before_index = null"></vue-gallery-slideshow>
            </div>
        </div>

        <div class="flex-grid">
            <div class="col">
                <h4>Grävning</h4>
                <img class="image" v-for="(image, i) in images_digging" :src="image" :key="i" @click="images_digging_index = i">
                <vue-gallery-slideshow :images="images_digging" :index="images_digging_index" @close="images_digging_index = null"></vue-gallery-slideshow>
            </div>

            <div class="col">
                <h4>Efter </h4>
                <img class="image" v-for="(image, i) in images_after" :src="image" :key="i" @click="images_after_index = i">
                <vue-gallery-slideshow :images="images_after" :index="images_after_index" @close="images_after_index = null"></vue-gallery-slideshow>
            </div>
        </div>

        <div class="flex-grid">
            <div class="col">
                <h4>Övrigt</h4>
                <img class="image" v-for="(image, i) in images_other" :src="image" :key="i" @click="images_other_index = i">
                <vue-gallery-slideshow :images="images_other" :index="images_other_index" @close="images_other_index = null"></vue-gallery-slideshow>
            </div>
        </div>
    </div>
</template>

<script>

    /* Input box - upload img
     https://codepen.io/tahazsh/pen/KrYwQb?source=post_page
    * https://levelup.gitconnected.com/how-to-preview-images-before-uploading-them-in-vue-4964803adb64*/

    import { db } from '../main'
    import { fbapp } from '../main'
    import { storage } from 'firebase';
    import VueGallery from 'vue-gallery';
    import VueGallerySlideshow from 'vue-gallery-slideshow';
    import VueSingleSelect from "vue-single-select";
    import jsPDF from "jspdf";
    import html2canvas from "html2canvas";
    import * as moment from 'moment';

    export default {
        name: "forsynPDF",
        components: {
            'gallery': VueGallery,
            VueGallerySlideshow,
            VueSingleSelect,
            moment
        },
        beforeMount(){
            const forsynID = this.$route.params.id;
            this.getForsynData(forsynID)
        },

        data() {
            return {
                someDate: null,
                msg: String,
                imageData: null,
                imageFile: null,
                imgCategory: null,
                imgCategories: [ "Före", "Försyn", "Grävning", "Efter", "Övrigt" ],
                datum_digging: null,
                datum_forsyn: null,
                choices: [
                    { value: "forsyn", text: "Försyn"},
                    { value: "before", text: "Före"},
                    { value: "digging", text: "Grävning"},
                    { value: "after", text: "Efter"},
                    { value: "other", text: "Övrigt"},
                ],
                choiceId: '',
                name: '',
                adress: '',
                postnr: '',
                ort: '',
                fastBet: '',
                email: '',
                color: '',
                phone: '',
                fk: false,
                ttt: false,
                dthv: false,
                fthv: false,
                invoiced: false,
                lawnmover_checked: false,
                water_checked: false,
                owncable_checked: false,
                customerComments: '',
                cable_colors: [{text: 'Välj färg på duct', value: null}, 'VI', 'BL', 'BR', 'GR','VL','GRÅ','RO','RÖ','SV','TU','OR','GU'],
                customers: [],
                images_forsyn: [],
                images_forsyn_index : null,
                images_before: [],
                images_before_index : null,
                images_after: [],
                images_after_index : null,
                images_digging: [],
                images_digging_index: null,
                images_other: [],
                images_other_index : null,
                image: '',
                image_before: '',
                imageUrl: '',
                imageData: '',  // we will store base64 format of image in this string
                images: [],
                index: null,
                saveImages: [],
                choiceText: null,
                noImages: null,
            }
        },
        firestore () {
            return {
                customers: db.collection('customers').orderBy('createdAt'),
                customer_images: db.collection('customers_images'),   /* Om inga bilder finns, visa ej. TYVÄRR Fungerar ej */
                if (customer_images = null) {
                    this.state.noImages = 1;
                }
            }
        },
        computed: { },            /* Hämtar ifrån store getters  */
        methods: {

            downloadWithCSS() {
                const doc = new jsPDF();
                /** WITH CSS */
                const canvasElement = document.createElement('canvas');
                html2canvas(this.$refs.content, { canvas: canvasElement }).then(function (canvas) {
                    const img = canvas.toDataURL("image/png");
                    doc.addImage(img,'JPEG',5,10);
                    doc.save("forsyn.pdf");
                });
            /*        this.$router.replace('/forsyn-list');*/
            },

            download() {
                const doc = new jsPDF();
                /** WITHOUT CSS */
                const contentHtml = this.$refs.content.innerHTML;
                doc.fromHTML(contentHtml, 15, 15, {
                    width: 170
                });
                doc.save("sample.pdf");
            },

            chooseImage () {
                this.$refs.fileInput.click()
            },
            getText() {
                const values = this.choices.map(function (o) {
                    return o.value
                });
                const index = values.indexOf(this.selected);
                console.log(this.choiceText = this.choices[index].value);
                this.saveNewImages(this.choiceText = this.choices[index].value);
            },

            saveNewImages(images) {
                this.saveImages.push(this.images);
                console.log(this.images);
            },

            onSelectFile ($event, imgCategory) {
                this.onFilePicked($event, imgCategory);
                const input = this.$refs.fileInput;
                const files = input.files;
                if (files && files[0]) {
                    const reader = new FileReader;
                    reader.onload = e => {
                        this.imageData = e.target.result
                    };
                    reader.readAsDataURL(files[0]);
                    this.$emit('input', files[0]);
                }
            },

            onFilePicked (event, imgCategory) {
                console.log(+ 'event + imgCategory ' + event + imgCategory );
                const files = event.target.files;
                let filename = files[0].name;
                if (filename.lastIndexOf('.') <= 0) {
                    return alert('Please add a valid file!')
                }
                const fileReader = new FileReader();
                fileReader.addEventListener('load', () => {
                    this.imageUrl = fileReader.result
                });
                fileReader.readAsDataURL(files[0]);
                this.image = files[0];

                const imageData = {
                    title: this.title,
                    creatorId: fbapp.auth().currentUser.uid,
                    image: this.image,
                    forsynid: this.$route.params.id,
                    imageType: imgCategory
                };
                /* Här skickar du ett objekt med inmformation om bilden till store för att lagras hos firebase*/
                this.$store.dispatch('createImage', imageData)
            },

            getForsynData : function(forsynid) {
                const docRef = db.collection("customers").doc(forsynid).get()
                    .then(snap => {
                        const docData = snap.data();

                        this.name = docData.name;
                        this.adress = docData.adress,
                            this.postnr = docData.postnr,
                            this.ort = docData.ort,
                            this.fastBet = docData.fastBet,
                            this.email = docData.email,
                            this.color = docData.color,
                            this.phone = docData.phone,
                            this.fk = docData.fk,
                            this.ttt = docData.ttt,
                            this.dthv = docData.dthv,
                            this.fthv = docData.fthv,
                            this.invoiced = docData.invoiced,
                            this.lawnmover_checked = docData.lawnmover_checked,
                            this.water_checked = docData.water_checked,
                            this.owncable_checked = docData.owncable_checked,
                            this.customerComments = docData.customerComments,
                            this.datum_forsyn = docData.datum_forsyn,
                            this.datum_digging = docData.datum_digging,
                            this.lng = docData.lng,
                            this.lat = docData.lat
                    })
                    .then(response => {
                        let imagesRef = db.collection("customers_images_" + forsynid)
                            .get().then(images => {
                                let data = images.docs.map(function (documentSnapshot) {
                                    return documentSnapshot.data();
                                });
                                this.downloadWithCSS();
                            })
                    });
            } ,            /* Methods - mutation = commit */
            addNewForsyn (name, adress, postnr, ort, fastBet, email, color, phone, fk, ttt, dthv, fthv,invoiced, lawnmover_checked, water_checked, owncable_checked, customerComments,datum_digging,datum_forsyn,lng,lat ) {
                const createdAt = new Date();
                console.log(fk);
                db.collection('customers').doc(this.$route.params.id).update({ name, adress, postnr, ort, fastBet, email, color, phone, fk, ttt, dthv, fthv,invoiced, lawnmover_checked, water_checked, owncable_checked, customerComments, createdAt,datum_digging,datum_forsyn,lng,lat })
                    .catch(function(error) {
                        console.error("Error writing document: ", error);
                        alert("Error writing document, try again");
                    });
                this.$router.replace('/forsyn-list');
            },
            getStorage : function(e) {
                return storage;
            },
        },
    }
</script>

<style scoped lang="scss">

    .container {
        align-items: flex-start;
        margin: 0;
        text-align: start;
        min-width: 100%;
        display: flex;
        flex-direction: column;
    }

    h4 {
        font-style: italic;
        color: #333;
        font-size: 12pt;
        padding: 0;
        margin: 5px 0;
    }

    span {
        font-size: 8pt;
        font-style: italic ;
        font-weight: 400;
    }

    .flex-grid {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
    }

    .col {
        flex: 1;
        flex-basis: 20%;
        display: flex;
        flex-direction: column;
        margin: 0;
    }

    /* Inserting this collapsed row between two flex items will make
   * the flex item that comes after it break to a new row */
    .break {
        flex-basis: 100%;
        height: 0;
    }

    input, .b-form-select, select {
        border: none;
        font-size: 9pt;
        font-weight: 300;
    }

    input, button,input[type=date]{
        padding: 5px 0;
    }

    .flatpickr-input, flatpickr-input active {
        font-size: 9pt;
        font-weight: 300;
        color: #333;
    }

    textarea.form-control {
        overflow-y: auto;
        font-size: 8pt;
        margin: 5px 0;
        padding: 5px;
        color: #333;
    }

    /* Styling för select file btn */
    form {
        width: 100%;
        margin: 0 auto;
        text-align: left;
    }

    .image-preview {
        padding: 10px;
    }


    img .preview {
        width: 100px;
        background-color: white;
        padding: 5px;
    }

    img {
        padding: 5px;
    }

    .image {
        float: left;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        margin: 1%;
        max-width: 30%;
    }

    @media only screen and (max-width: 992px) {
        .container {
            min-width: 100%;
        }

        .col {
            flex: 1;
            flex-basis: 25%;
            display: flex;
            flex-direction: column;
            margin: 0;
        }

        button {
            padding: 5px 10px;
        }

        select {
            font-size: 10pt;
        }
    }

    @media (max-width: 400px) {
        .flex-grid {
            display: block;
        }
    }
</style>
<!-- Du kan animera både på v-if (vanligast) och på v-show-->



// WEBPACK FOOTER //
// src/views/forsynPDF.vue